<template>
  <div>
    <div class="booking-status">
      <div class="status">
        <div class="booking-step" :class="this.value ? 'action' : ''">
          <div class="text-step">1</div>
        </div>
        <div class="booking-step" :class="this.value >= 2 ? 'action' : ''">
          <div class="text-step">2</div>
        </div>
        <div class="booking-step" :class="this.value === 3 ? 'action' : ''">
          <div class="text-step">3</div>
        </div>
        <div class="line"></div>
      </div>
    </div>
    <div class="status-text">
      <div class="booking-detail">
        <div class="text-step left">จองห้อง</div>
      </div>
      <div class="booking-detail center">
        <div class="text-step">แสดงข้อมูลลูกค้า</div>
      </div>
      <div class="booking-detail over-size">
        <div class="text-step right">จองห้องสำเร็จ</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.booking-status {
  width: 100%;
  position: relative;
}

.status {
  padding: 0;
  justify-content: space-between;
  display: flex;
  width: 600px;
  margin: auto;
}

.status-text {
  padding: 0;
  width: 800px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.line {
  position: absolute;
  border: solid 1px $color-light-gray-1;
  top: 50%;
  width: 600px;
}

.booking-step {
  flex-direction: column;
  height: 64px;
  width: 64px;
  border: solid 1px $color-light-gray-1;
  border-radius: 50%;
  background-color: $white;
  z-index: 1;
  text-align: center;
  font-size: 32px;
  font-style: Medium;
  color: $light-gray-2;
}

.booking-detail {
  flex-direction: column;
  width: auto;
  z-index: 1;
  text-align: center;
  font-size: $font-20;
  font-style: Medium;
  color: $light-gray-2;
}

.action {
  background-color: $color-orange;
  color: $white;
}

.text-step {
  margin-top: 6px;
}

@media screen and (max-width: $m-size) {
  .booking-step {
    height: 55px;
    width: 55px;

    .text-step {
      margin-top: 1px;
    }
  }

  .status {
    width: 100%;
  }

  .line {
    width: 100%;
  }

  .status-text {
    width: 100%;
  }

  .booking-detail {
    font-size: $font-14;

    .left {
      text-align: left;
      padding-left: 5px;
    }

    .right {
      text-align: right;
    }
  }

  .over-size {
    width: 110%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/BookingStatus.vue